import React, { useState } from "react";
import styles from "./FieldTypeModal.module.scss";
import { ConditionalDropdownFiledIcon, DateFiledIcon, DropdownFiledIcon, FileUploadFiledIcon, NumberFiledIcon, TextDescriptionFiledIcon, TextFiledIcon, TimeFiledIcon, ToggleFiledIcon } from "../../../../../../assets/icons";
import { DropdownFiledConfiguration } from "./configurations/DropdownFiledConfiguration";
import { TextFieldConfiguration } from "./configurations/TextFieldConfiguration";
import { FileUploadFieldConfiguration } from "./configurations/FileUploadFieldConfiguration";
import { NumberFieldConfiguration } from "./configurations/NumberFieldConfiguration";
import { TextDescriptionFieldConfiguration } from "./configurations/TextDescriptionFieldConfiguration";
import { ToggleConfiguration } from "./configurations/ToggleFieldConfiguration";
import { ConditionalDropdownFiledConfiguration } from "./configurations/ConditionalDropdownFiledConfiguration";
import { DateAndTimeFieldConfiguration } from "./configurations/DateAndTimeFieldConfiguration";
import { Attribute, FieldType, getFieldTypeString } from "../../../../../../model/service-request/attribute";
import { useDispatch } from "react-redux";
import { addField } from "../../../../../../stores/slices/service-type-slice";
import { addFieldToStepAdditionalServiceRequest } from "../../../../../../stores/slices/workflow-slice";
import { toast } from "react-toastify";

type Props = {
  onModalClose: () => void
  existingAttribute? : Attribute,
  sectionIndex: number
  stepId?: string;
}

const FieldTypeModal = (props: Props) => {
  const [selectedFieldType, setSelectedFieldType] = useState<FieldType | undefined>(
    props.existingAttribute ? props.existingAttribute.fieldType : FieldType.Text);
  const dispatch = useDispatch();


  const getFiledIcon = (type:FieldType) => {
    switch (type) {
              case FieldType.Dropdown : return <DropdownFiledIcon />
              case FieldType.ConditionalDropdown : return <ConditionalDropdownFiledIcon />
              case FieldType.Text: return <TextFiledIcon />
              case FieldType.TextDescription : return <TextDescriptionFiledIcon />
              case FieldType.File : return <FileUploadFiledIcon />
              case FieldType.Bool: return <ToggleFiledIcon />
              case FieldType.Number: return <NumberFiledIcon />
              case FieldType.DateTime : return <DateFiledIcon />
      default:
        break;
    }
  }

  const saveField = (attr: Attribute) => {
    if(attr.label != ""){
      if (props.stepId) {
        dispatch(addFieldToStepAdditionalServiceRequest({
          stepId: props.stepId,
          newAttribute: attr,
          existingAttribute: props.existingAttribute,
          sectionIndex: props.sectionIndex
        }));
      } else {
        dispatch(addField({newAttribute:attr, existingAttribute: props.existingAttribute,sectionIndex: props.sectionIndex}));
      }
      props.onModalClose();
    }
    else{
      toast.warning("'Field Name' is required")
    }
    
  }

  return (
    <div className={styles.modalOverlay} onClick={() => console.log("backdrop click")}>
      <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
        <button className={styles.closeBtn} onClick={() => props.onModalClose()}>
          ×
        </button>

        {/* Field type options */}
        <div className={styles.modalSplit}>
          <div>
            <div className={styles.modalHeader}>Select Field Type</div>
            <div className={styles.fieldTypeOptions}>
              {[
                FieldType.Dropdown,
                FieldType.ConditionalDropdown,
                FieldType.Text,
                FieldType.TextDescription,
                FieldType.File,
                FieldType.Bool,
                FieldType.Number,
                FieldType.DateTime
              ].map((type) => (
                <button
                  key={type}
                  className={` ${styles.optionBtn} ${
                    selectedFieldType === type ? styles.selected : ""
                  }`}
                  onClick={() => setSelectedFieldType(type)}
                >
                  <div className={styles.optionIcon}>
                    {getFiledIcon(type)}
                  </div>
                  {getFieldTypeString(type)}
                </button>
              ))}
            </div>
          </div>

          {/* Right-hand side settings */}
          <div className={styles.fieldSettings}>
            <div className={styles.fieldTypeTitle}>
              <span>{selectedFieldType && getFieldTypeString(selectedFieldType)}</span>
            </div>

            {selectedFieldType === FieldType.Dropdown && (
              <DropdownFiledConfiguration onFieldSave={saveField} existingAttribute={props.existingAttribute}/>
            )}

            {selectedFieldType === FieldType.Text && (
              <TextFieldConfiguration onFieldSave={saveField}  existingAttribute={props.existingAttribute}/>
            )}

            {selectedFieldType === FieldType.File && (
              <FileUploadFieldConfiguration onFieldSave={saveField}  existingAttribute={props.existingAttribute}/>
            )}

            {selectedFieldType === FieldType.Number && (
              <NumberFieldConfiguration onFieldSave={saveField}  existingAttribute={props.existingAttribute}/>
            )}

            {selectedFieldType === FieldType.TextDescription && (
              <TextDescriptionFieldConfiguration onFieldSave={saveField}  existingAttribute={props.existingAttribute}/>
            )}

            {selectedFieldType === FieldType.Bool && (
              <ToggleConfiguration onFieldSave={saveField}  existingAttribute={props.existingAttribute} />
            )}
            
            {selectedFieldType === FieldType.ConditionalDropdown && (
              <ConditionalDropdownFiledConfiguration onFieldSave={saveField}  existingAttribute={props.existingAttribute}/>
            )}

            {selectedFieldType === FieldType.DateTime && (
              <DateAndTimeFieldConfiguration onFieldSave={saveField}  existingAttribute={props.existingAttribute}/>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FieldTypeModal;
